<div class="width-1100">

  <mat-card>
    <mat-toolbar class="toolbar-top">

      <div class='title'>
        <mat-icon>noise_control_off</mat-icon>
        <div>Código de Conduta</div>
      </div>

      <div flex justify-content='flex-end' fxLayoutAlign="end">
      </div>

    </mat-toolbar>

  </mat-card>

    <mat-card>
    <div class="document-card">

      <div class="file-container">
        <input #filePDF type="file" accept='application/pdf' style="display:none;" (change)="pdfChange($event)" />
        <a mat-button (click)='filePDF.click()' matTooltip='Selecionar PDF'
          style='background-color: whitesmoke;  margin-right: 5px;'>
          <mat-icon class='icon-add'>picture_as_pdf</mat-icon>
        </a>

        <div class="file-info">
          <span *ngIf="pdfDocument$ | async as doc">
            PDF: <a [href]="doc.pdf_url" target="_blank">{{doc.pdf_name}}</a>
          </span>
          <span *ngIf="!pdfDocument$">
            PDF: nenhum arquivo selecionado
          </span>
        </div>

      </div>

      <div class="actions-container">

        <a mat-button (click)='savePDF()' matTooltip='Salvar PDF' style="background-color: whitesmoke;">
          <mat-icon class='icon-done'>check_circle_outline</mat-icon>
        </a>

        <a mat-button (click)="openDeletePDF('statute')" matTooltip='Apagar PDF'
          style="background-color: whitesmoke; margin-right: 30px;">
          <mat-icon class='icon-delete'>delete_outline</mat-icon>
        </a>

      </div>

    </div>

  </mat-card>
  
  <mat-card>
    <mat-tab-group>
      <mat-tab>
        <ng-template mat-tab-label>
          <div>Texto</div>
        </ng-template>

        <div *ngIf="entityForm">
          <ckeditor [editor]="Editor" [config]="editorConfig" [formControl]="entityForm.controls.text"
            (ready)="onReady($event)" (change)="onChange($event)"> </ckeditor>
        </div>

      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <div>HTML</div>
        </ng-template>


        <textarea class='text-area' autocomplete="off" [(ngModel)]="htmlContent" [ngModelOptions]="{ standalone: true }"
          (input)="entityForm.controls.text.setValue(htmlContent, { emitEvent: false })">
          </textarea>

      </mat-tab>

      <mat-tab *ngIf="false">
        <ng-template mat-tab-label>
          <div>Imagens</div>
        </ng-template>

        <mat-card class="image-area">
          <app-file-manager [image_path]="'site_pub/history'">
          </app-file-manager>
        </mat-card>

      </mat-tab>

    </mat-tab-group>
  </mat-card>

  <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>
    <button matTooltip='Gravar' mat-raised-button (click)="saveData()">
      <mat-icon class='icon-done'>check_circle_outline</mat-icon>
    </button>

  </div>


</div>